/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Teaser/theme';

export const TeaserTheme = theme;
